<h3 class="ms-10 text-xl text-amazone-gray font-semibold">
  <span class="me-4 italic">{{ currentLanguage }}</span>
  <span class="text-amazone-orange font-bold">{{ currentSwPartNumber }}</span>
</h3>
